import { sections } from "../SitemapData"

export default function getSections(includeHidden: boolean = false) {
    if (includeHidden) return sections
    return sections.filter(section => !section.hide)
}
